import Vue from 'vue';
import moment from 'moment';

Vue.filter('niceDate', (date) => moment(date, 'DD-MM-YYYY').format('dddd DD MMMM YYYY'));

Vue.filter('humanizeDate', (date) => moment.duration(moment(date, 'DD-MM-YYYY').diff(moment())).humanize(true));

Vue.filter('niceMoney', (amount) => {
  const formatter = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
  });

  return formatter.format(amount);
});
